import { effect, Signal } from '@angular/core';
import { AbstractControl } from '@angular/forms';

export function toggleControlState(
    enableSignal: Signal<boolean>,
    formControl: AbstractControl
) {
    return effect(() => {
        const shouldEnable = enableSignal();

        if (shouldEnable) {
            formControl.enable();
        } else {
            formControl.setValue([]);
            formControl.disable();
        }
    });
}

export function trailingSpaceCleaner(control: AbstractControl): string {
    const value = control.value;

    if (typeof value === 'string') {
        return value.trim();
    }

    return value?.toString() || '';
}